Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedScrollHandler = void 0;
var _Hooks = require("./Hooks");
var _worklet_17515480971732_init_data = {
    code: "function anonymous(event){const{scrollHandlers,context}=this.__closure;const{onScroll:onScroll,onBeginDrag:onBeginDrag,onEndDrag:onEndDrag,onMomentumBegin:onMomentumBegin,onMomentumEnd:onMomentumEnd}=scrollHandlers;if(onScroll&&event.eventName.endsWith('onScroll')){onScroll(event,context);}else if(onBeginDrag&&event.eventName.endsWith('onScrollBeginDrag')){onBeginDrag(event,context);}else if(onEndDrag&&event.eventName.endsWith('onScrollEndDrag')){onEndDrag(event,context);}else if(onMomentumBegin&&event.eventName.endsWith('onMomentumScrollBegin')){onMomentumBegin(event,context);}else if(onMomentumEnd&&event.eventName.endsWith('onMomentumScrollEnd')){onMomentumEnd(event,context);}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedScrollHandler.ts",
    sourceMap: '{"version":3,"names":["anonymous","event","scrollHandlers","context","__closure","onScroll","onBeginDrag","onEndDrag","onMomentumBegin","onMomentumEnd","eventName","endsWith"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedScrollHandler.ts"],"mappings":"AAiEI,QAAC,CAAAA,SAAuBA,CAAAC,KAAA,QAAAC,cAAA,CAAAC,OAAA,OAAAC,SAAA,CAEtB,KAAM,CACJC,QAAQ,CAARA,QAAQ,CACRC,WAAW,CAAXA,WAAW,CACXC,SAAS,CAATA,SAAS,CACTC,eAAe,CAAfA,eAAe,CACfC,aAAA,CAAAA,aACF,CAAC,CAAGP,cAAc,CAClB,GAAIG,QAAQ,EAAIJ,KAAK,CAACS,SAAS,CAACC,QAAQ,CAAC,UAAU,CAAC,CAAE,CACpDN,QAAQ,CAACJ,KAAK,CAAEE,OAAO,CAAC,CAC1B,CAAC,IAAM,IAAIG,WAAW,EAAIL,KAAK,CAACS,SAAS,CAACC,QAAQ,CAAC,mBAAmB,CAAC,CAAE,CACvEL,WAAW,CAACL,KAAK,CAAEE,OAAO,CAAC,CAC7B,CAAC,IAAM,IAAII,SAAS,EAAIN,KAAK,CAACS,SAAS,CAACC,QAAQ,CAAC,iBAAiB,CAAC,CAAE,CACnEJ,SAAS,CAACN,KAAK,CAAEE,OAAO,CAAC,CAC3B,CAAC,IAAM,IACLK,eAAe,EACfP,KAAK,CAACS,SAAS,CAACC,QAAQ,CAAC,uBAAuB,CAAC,CACjD,CACAH,eAAe,CAACP,KAAK,CAAEE,OAAO,CAAC,CACjC,CAAC,IAAM,IACLM,aAAa,EACbR,KAAK,CAACS,SAAS,CAACC,QAAQ,CAAC,qBAAqB,CAAC,CAC/C,CACAF,aAAa,CAACR,KAAK,CAAEE,OAAO,CAAC,CAC/B,CACF"}',
    version: "3.5.4"
};
var useAnimatedScrollHandler = exports.useAnimatedScrollHandler = function useAnimatedScrollHandler(handlers, dependencies) {
    var scrollHandlers = typeof handlers === "function" ? {
        onScroll: handlers
    } : handlers;
    var _useHandler = (0, _Hooks.useHandler)(scrollHandlers, dependencies), context = _useHandler.context, doDependenciesDiffer = _useHandler.doDependenciesDiffer;
    var subscribeForEvents = [
        "onScroll"
    ];
    if (scrollHandlers.onBeginDrag !== undefined) {
        subscribeForEvents.push("onScrollBeginDrag");
    }
    if (scrollHandlers.onEndDrag !== undefined) {
        subscribeForEvents.push("onScrollEndDrag");
    }
    if (scrollHandlers.onMomentumBegin !== undefined) {
        subscribeForEvents.push("onMomentumScrollBegin");
    }
    if (scrollHandlers.onMomentumEnd !== undefined) {
        subscribeForEvents.push("onMomentumScrollEnd");
    }
    return (0, _Hooks.useEvent)(function() {
        var _e = [
            new global.Error(),
            -3,
            -27
        ];
        var anonymous = function anonymous(event) {
            var onScroll = scrollHandlers.onScroll, onBeginDrag = scrollHandlers.onBeginDrag, onEndDrag = scrollHandlers.onEndDrag, onMomentumBegin = scrollHandlers.onMomentumBegin, onMomentumEnd = scrollHandlers.onMomentumEnd;
            if (onScroll && event.eventName.endsWith("onScroll")) {
                onScroll(event, context);
            } else if (onBeginDrag && event.eventName.endsWith("onScrollBeginDrag")) {
                onBeginDrag(event, context);
            } else if (onEndDrag && event.eventName.endsWith("onScrollEndDrag")) {
                onEndDrag(event, context);
            } else if (onMomentumBegin && event.eventName.endsWith("onMomentumScrollBegin")) {
                onMomentumBegin(event, context);
            } else if (onMomentumEnd && event.eventName.endsWith("onMomentumScrollEnd")) {
                onMomentumEnd(event, context);
            }
        };
        anonymous.__closure = {
            scrollHandlers: scrollHandlers,
            context: context
        };
        anonymous.__initData = _worklet_17515480971732_init_data;
        anonymous.__workletHash = 17515480971732;
        anonymous.__stackDetails = _e;
        return anonymous;
    }(), subscribeForEvents, doDependenciesDiffer);
};
